import React from 'react';
import { Check } from 'lucide-react';

interface FeatureCheckProps {
  text: string;
  variant?: 'light' | 'dark';
  className?: string;
}

export const FeatureCheck: React.FC<FeatureCheckProps> = ({
  text,
  variant = 'light',
  className = '',
}) => {
  const textColor = variant === 'light' ? 'text-blue-100' : 'text-dark-700';
  const bgColor = variant === 'light' ? 'bg-white/20' : 'bg-blue-700/20';
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`flex items-center justify-center w-6 h-6 rounded-full ${bgColor}`}>
        <Check className={`h-4 w-4 ${variant === 'light' ? 'text-white' : 'text-blue-700'}`} />
      </div>
      <span className={textColor}>{text}</span>
    </div>
  );
};
